<template>
  <div class="loading">
    <slot/>
    <div v-if="display==='v1'" class="loader"><img :src="loadingImg"
                                                   alt="Loading Content..."/>
    </div>
    <span v-else class="ouro">
            <span class="left"><span class="anim"></span></span>
            <span class="right"><span class="anim"></span></span>
        </span>
  </div>

</template>

<script>
  export default {
    name: "loading",
    computed: {
      loadingImg() {
        return window.vueLoadingImg;
      }
    },
    props: {
      display: {
        type: String,
        default: 'default'
      }
    }
  }
</script>

<style scoped>

  .loading {
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width:100%;
  }

  .loader {
    font-size: 10px;
    margin: 50px auto;
    text-indent: -9999em;
    width: 11em;
    height: 11em;
    border-radius: 50%;
    background: #000;
    background: -moz-linear-gradient(left, #444 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, #444 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, #444 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, #444 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, #444 10%, rgba(255, 255, 255, 0) 42%);
    position: relative;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }

  .loader:before {
    width: 50%;
    height: 50%;
    background: #000;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }

  .loader:after {
    background: #fff;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .ouro {
    position: relative;
    display: inline-block;
    height: 64px;
    width: 64px;
    margin: 1em;
    border-radius: 50%;
    background: none repeat scroll 0 0 #f0f0ed;
    background: none repeat scroll 0 0 var(--nav-background);
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1) inset, 0 0 25px rgba(0, 0, 255, 0.075);
  }

  .ouro:after {
    content: "";
    position: absolute;
    top: 9px;
    left: 9px;
    display: block;
    height: 46px;
    width: 46px;
    background: none repeat scroll 0 0 #FFFFFF;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
  }

  .ouro > span {
    position: absolute;
    height: 100%;
    width: 50%;
    overflow: hidden;
  }

  .left {
    left: 0
  }

  .right {
    left: 50%
  }

  .anim {
    position: absolute;
    left: 100%;
    top: 0;
    height: 100%;
    width: 100%;
    border-radius: 999px;
    background: none repeat scroll 0 0 #0088CC;
    background: none repeat scroll 0 0 var(--primary);
    opacity: 0.8;
    will-change: transform;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    -o-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
    -moz-animation-timing-function: linear;
    -o-animation-timing-function: linear;
    animation-timing-function: linear;
    -webkit-animation-duration: 3s;
    -moz-animation-duration: 3s;
    -o-animation-duration: 3s;
    animation-duration: 3s;
  }

  .left .anim {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    -webkit-transform-origin: 0 50% 0;
    -moz-transform-origin: 0 50% 0;
    -ms-transform-origin: 0 50% 0;
    -o-transform-origin: 0 50% 0;
    transform-origin: 0 50% 0;
    -webkit-animation-name: ui-spinner-rotate-left;
    -moz-animation-name: ui-spinner-rotate-left;
    -o-animation-name: ui-spinner-rotate-left;
    animation-name: ui-spinner-rotate-left;
  }

  .right .anim {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    left: -100%;
    -webkit-transform-origin: 100% 50% 0;
    -moz-transform-origin: 100% 50% 0;
    -ms-transform-origin: 100% 50% 0;
    -o-transform-origin: 100% 50% 0;
    transform-origin: 100% 50% 0;
    -webkit-animation-name: ui-spinner-rotate-right;
    -moz-animation-name: ui-spinner-rotate-right;
    -o-animation-name: ui-spinner-rotate-right;
    animation-name: ui-spinner-rotate-right;
  }

  @keyframes ui-spinner-rotate-left {
    0% {
      transform: rotate(0deg)
    }
    25% {
      transform: rotate(180deg)
    }
    50% {
      transform: rotate(180deg)
    }
    75% {
      transform: rotate(360deg)
    }
    100% {
      transform: rotate(360deg)
    }
  }

  @-webkit-keyframes ui-spinner-rotate-left {
    0% {
      -webkit-transform: rotate(0deg)
    }
    25% {
      -webkit-transform: rotate(180deg)
    }
    50% {
      -webkit-transform: rotate(180deg)
    }
    75% {
      -webkit-transform: rotate(360deg)
    }
    100% {
      -webkit-transform: rotate(360deg)
    }
  }

  @-o-keyframes ui-spinner-rotate-left {
    0% {
      -o-transform: rotate(0deg)
    }
    25% {
      -o-transform: rotate(180deg)
    }
    50% {
      -o-transform: rotate(180deg)
    }
    75% {
      -o-transform: rotate(360deg)
    }
    100% {
      -o-transform: rotate(360deg)
    }
  }

  @-moz-keyframes ui-spinner-rotate-left {
    0% {
      -moz-transform: rotate(0deg)
    }
    25% {
      -moz-transform: rotate(180deg)
    }
    50% {
      -moz-transform: rotate(180deg)
    }
    75% {
      -moz-transform: rotate(360deg)
    }
    100% {
      -moz-transform: rotate(360deg)
    }
  }

  @keyframes ui-spinner-rotate-right {
    0% {
      transform: rotate(0deg)
    }
    25% {
      transform: rotate(0deg)
    }
    50% {
      transform: rotate(180deg)
    }
    75% {
      transform: rotate(180deg)
    }
    100% {
      transform: rotate(360deg)
    }
  }

  @-webkit-keyframes ui-spinner-rotate-right {
    0% {
      -webkit-transform: rotate(0deg)
    }
    25% {
      -webkit-transform: rotate(0deg)
    }
    50% {
      -webkit-transform: rotate(180deg)
    }
    75% {
      -webkit-transform: rotate(180deg)
    }
    100% {
      -webkit-transform: rotate(360deg)
    }
  }

  @-moz-keyframes ui-spinner-rotate-right {
    0% {
      -moz-transform: rotate(0deg)
    }
    25% {
      -moz-transform: rotate(0deg)
    }
    50% {
      -moz-transform: rotate(180deg)
    }
    75% {
      -moz-transform: rotate(180deg)
    }
    100% {
      -moz-transform: rotate(360deg)
    }
  }

  @-o-keyframes ui-spinner-rotate-right {
    0% {
      -o-transform: rotate(0deg)
    }
    25% {
      -o-transform: rotate(0deg)
    }
    50% {
      -o-transform: rotate(180deg)
    }
    75% {
      -o-transform: rotate(180deg)
    }
    100% {
      -o-transform: rotate(360deg)
    }
  }


</style>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/components/global/loading.vue